import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@garnet/ui/styles/garnet.css';
import './styles/console.css';
import { App } from './App.js';

const el = document.getElementById('root');
if (!el) throw new Error('missing #root mount node');

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
